const config = window.AbdelmegedTheme || {};
const buttons = document.querySelectorAll('[data-sound-toggle]');
const sound = window.AbdelmegedSound;

const update = () => {
  const isEnabled = Boolean(sound?.enabled());

  buttons.forEach((button) => {
    const label = button.querySelector('[data-sound-toggle-label]');
    const icon = button.querySelector('i');

    button.setAttribute('aria-pressed', String(isEnabled));
    button.classList.toggle('is-sound-enabled', isEnabled);

    if (icon) {
      icon.classList.toggle('fa-volume-high', isEnabled);
      icon.classList.toggle('fa-volume-xmark', !isEnabled);
    }

    if (label) {
      label.textContent = isEnabled ? 'Sounds on' : 'Sounds off';
    }
  });
};

if (config.features?.sound === true && sound) {
  update();
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      sound.setEnabled(!sound.enabled());
      update();
      sound.play('tap');
    });
  });
}
